import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const unscheduleUnitCancellation = async (unitId: string): Promise<boolean> =>
  axios.delete(`/unit/unscheduleunitcancellation?unitId=${unitId}`).then((res) => res?.data?.result)

type Props = {
  unitId: string
}

export const useUnscheduleUnitCancellation = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['unscheduleUnitCancellation'],
    mutationFn: ({ unitId }: Props) => unscheduleUnitCancellation(unitId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Removed scheduled cancellation.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to remove scheduled cancellation, please try again.')
      }
    },
    throwOnError: false
  })
